module.exports = __webpack_public_path__ + "img/history-1.731cacf7.png";